import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Consultation from "./sections/Consultation";
import Coverage from "./sections/Coverage";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Hero />
      <Consultation />
      <Coverage />
      <Footer />
    </div>;
}